import './IssueLabelToken-99c9b914.css';

var classes = {"IssueLabel":"prc-Token-IssueLabel-ZuoEW","RemoveButton":"prc-Token-RemoveButton-H4Dmg"};

export { classes as default };
